<div class="container-">
    <survey #survey [uid]="uid" [json]="json" [result]="answers" [isDisabled]="isDisabled" (submitSurvey)="onSurveySubmitted($event)"></survey>
</div>
